/* eslint-disable import/no-anonymous-default-export */
export default (requisition = [], action) => {
  switch (action.type) {
    case "GET_REQUISITIONS":
      return action.payload;
    default:
      return requisition;
  }
};
